/** Minimal cookie helpers (no dependency). */

export function getCookie(name: string): string | null {
  if (typeof document === "undefined") return null
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${encodeURIComponent(name)}=`))
  if (!match) return null
  return decodeURIComponent(match.slice(match.indexOf("=") + 1))
}

export function setCookie(
  name: string,
  value: string,
  options: { days?: number; path?: string } = {},
): void {
  if (typeof document === "undefined") return
  const { days = 90, path = "/" } = options
  const expires = new Date(Date.now() + days * 864e5).toUTCString()
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; expires=${expires}; path=${path}; SameSite=Lax`
}
